import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import enIE from './locales/en-IE.json'
import enGB from './locales/en-GB.json'
import enUS from './locales/en-US.json'

// Ireland is the default locale
const DEFAULT_LOCALE = 'en-IE'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      'en-IE': { translation: enIE },
      'en-GB': { translation: enGB },
      'en-US': { translation: enUS },
    },
    lng: DEFAULT_LOCALE,
    fallbackLng: DEFAULT_LOCALE,
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false, // React already escapes
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
  })

export default i18n

